export default "__VITE_ASSET__CEYoKmaH__"